import { getRangeIndexes, setCellFormat, applyCellFormat, activeCellChanged, isReadOnly, isReadOnlyCells, mergedRange, setMerge, updateMergeBorder } from '../common/index';
import { getSwapRange, textDecorationUpdate } from '../common/index';
import { clear, getIndexesFromAddress, activeCellMergedRange, deleteHyperlink } from '../common/index';
import { getSheetIndex, isHiddenRow, getSheet, getCell, setCell, updateCFModel, getColumn } from '../index';
import { getRow, updateCell, isHeightCheckNeeded, workbookFormulaOperation } from '../index';
import { applyCF, getColorCode } from '../index';
import { checkColumnValidation, updateHighlight } from '../index';
import { processSheetComments, processSheetNotes } from '../../spreadsheet/common/event';
/**
 * Workbook Cell format.
 */
export class WorkbookCellFormat {
    constructor(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    format(args) {
        let ranges = [];
        let sheet;
        let rng = args.range;
        let triggerEvt;
        if (rng && typeof rng === 'string') {
            if (rng.indexOf('!') > -1) {
                const lastIndex = rng.lastIndexOf('!');
                rng = rng.substring(lastIndex + 1);
                sheet = this.parent.sheets[getSheetIndex(this.parent, args.range.substring(0, lastIndex))];
            }
            else {
                sheet = this.parent.getActiveSheet();
            }
            ranges = rng.split(' ');
            triggerEvt = args.onActionUpdate && !args.isUndoRedo;
        }
        else {
            sheet = this.parent.getActiveSheet();
            if (rng === undefined) {
                rng = sheet.selectedRange;
                ranges = rng.split(' ');
                triggerEvt = args.onActionUpdate && !args.isUndoRedo;
            }
            else {
                ranges = [rng];
            }
        }
        if (ranges.some((rng) => isReadOnlyCells(this.parent, typeof rng === 'string' ? getSwapRange(getRangeIndexes(rng)) : rng, args.onActionUpdate))) {
            return;
        }
        const eventArgs = { range: rng, style: Object.assign({}, args.style), requestType: 'CellFormat' };
        if (args.borderType) {
            eventArgs.borderType = args.borderType;
        }
        if (triggerEvt) {
            this.parent.trigger('beforeCellFormat', eventArgs);
            this.parent.notify('actionBegin', { eventArgs: eventArgs, action: 'format' });
            if (eventArgs.cancel) {
                args.cancel = true;
                return;
            }
            if (eventArgs.range !== rng) {
                rng = eventArgs.range;
                ranges = rng.split(' ');
            }
        }
        let indexes;
        let mergeBorderRows;
        let i;
        let j;
        const props = { cell: null, rowIdx: 0, colIdx: 0, eventOnly: true, preventEvt: !triggerEvt };
        const triggerBeforeEvent = (cellStyle) => {
            props.cell = { style: cellStyle };
            props.rowIdx = i;
            props.colIdx = j;
            return updateCell(this.parent, sheet, props);
        };
        const updateStylesFn = () => {
            let border;
            let isFullBorder;
            const styleKeys = Object.keys(eventArgs.style);
            if (styleKeys.length) {
                let cell;
                let validation;
                let col;
                const parent = this.parent;
                const activeSheet = parent.viewport && this.parent.getActiveSheet().id === sheet.id;
                const frozenRow = this.parent.frozenRowCount(sheet);
                const frozenCol = this.parent.frozenColCount(sheet);
                const viewport = [frozenRow + parent.viewport.topIndex, frozenCol + parent.viewport.leftIndex,
                    parent.viewport.bottomIndex, parent.viewport.rightIndex];
                let uiRefresh;
                let row;
                let checkHeight;
                let formatColor;
                const isFontColorApplied = styleKeys.indexOf('color') > -1;
                const isColorApplied = isFontColorApplied || styleKeys.indexOf('backgroundColor') > -1;
                return () => {
                    for (i = indexes[0]; i <= indexes[2]; i++) {
                        row = getRow(sheet, i) || {};
                        if (row.isFiltered) {
                            continue;
                        }
                        uiRefresh = (i >= viewport[0] && i <= viewport[2]) || i < frozenRow;
                        checkHeight = false;
                        for (j = indexes[1]; j <= indexes[3]; j++) {
                            if (triggerBeforeEvent(eventArgs.style)) {
                                continue;
                            }
                            if (isFullBorder === undefined && eventArgs.style.border !== undefined) {
                                border = eventArgs.style.border;
                                delete eventArgs.style.border;
                                isFullBorder = true;
                            }
                            cell = getCell(i, j, sheet, false, true);
                            col = sheet.columns[j];
                            if (cell.rowSpan > 1 || cell.colSpan > 1) {
                                for (let k = i, rowSpanLen = cell.rowSpan > 1 ? i + (cell.rowSpan - 1) : i; k <= rowSpanLen; k++) {
                                    for (let l = j, colSpanLen = cell.colSpan > 1 ? j + (cell.colSpan - 1) : j; l <= colSpanLen; l++) {
                                        if (isFullBorder) {
                                            this.setFullBorder(sheet, border, indexes, k, l, args.onActionUpdate, true);
                                        }
                                        this.setCellStyle(sheet, k, l, eventArgs.style);
                                    }
                                }
                            }
                            if (isFullBorder) {
                                this.setFullBorder(sheet, border, indexes, i, j, args.onActionUpdate, undefined, mergeBorderRows);
                            }
                            this.setCellStyle(sheet, i, j, eventArgs.style);
                            if (!activeSheet) {
                                continue;
                            }
                            if (uiRefresh && ((j >= viewport[1] && j <= viewport[3]) || j < frozenCol)) {
                                formatColor = null;
                                if (isFontColorApplied && cell.format && cell.format.includes('[')) {
                                    const colorCode = getColorCode(cell.format);
                                    if (colorCode) {
                                        formatColor = colorCode.toLowerCase();
                                    }
                                }
                                this.parent.notify(applyCellFormat, {
                                    style: eventArgs.style, rowIdx: i, colIdx: j,
                                    lastCell: j === indexes[3], isHeightCheckNeeded: true, manualUpdate: true,
                                    onActionUpdate: args.onActionUpdate, formatColor: formatColor
                                });
                                if (isColorApplied) {
                                    validation = cell.validation || (checkColumnValidation(col, i, j) && col.validation);
                                    if (validation && validation.isHighlighted) {
                                        this.parent.notify(updateHighlight, {
                                            rowIdx: i, colIdx: j, cell: cell, validation: validation, col: cell.validation && col
                                        });
                                    }
                                }
                            }
                            else if (!row.customHeight) {
                                checkHeight = checkHeight || isHeightCheckNeeded(eventArgs.style, args.onActionUpdate);
                                if (checkHeight) {
                                    this.parent.notify(applyCellFormat, {
                                        rowIdx: i, colIdx: j, lastCell: j === indexes[3], checkHeight: true,
                                        outsideViewport: !uiRefresh, onActionUpdate: args.onActionUpdate
                                    });
                                }
                            }
                        }
                    }
                };
            }
            else {
                return () => { };
            }
        };
        const style = {};
        Object.assign(style, eventArgs.style, null, true);
        let updateStyles;
        ranges.forEach((currentRange, index) => {
            indexes = typeof currentRange === 'string' ? getSwapRange(getRangeIndexes(currentRange)) : currentRange;
            Object.assign(eventArgs.style, style);
            mergeBorderRows = [];
            if (args.borderType) {
                this.setTypedBorder(sheet, args.style.border, indexes, args.borderType, args.onActionUpdate, mergeBorderRows);
                if (index === ranges.length - 1) {
                    delete args.style.border;
                }
                delete eventArgs.style.border;
            }
            if (eventArgs.style.borderTop !== undefined) {
                for (j = indexes[1]; j <= indexes[3]; j++) {
                    i = indexes[0];
                    if (!triggerBeforeEvent({ borderTop: eventArgs.style.borderTop })) {
                        if (!args.isUndoRedo) {
                            this.checkAdjacentBorder(sheet, 'borderBottom', i - 1, j);
                            this.checkFullBorder(sheet, 'borderBottom', i - 1, j);
                        }
                        this.checkFullBorder(sheet, 'borderTop', i, j);
                        this.setCellBorder(sheet, props.cell.style, i, j, args.onActionUpdate, j === indexes[3], null, null, args.isUndoRedo, mergeBorderRows);
                    }
                }
                delete eventArgs.style.borderTop;
            }
            if (eventArgs.style.borderBottom !== undefined) {
                let firstCell;
                let lastCell;
                for (j = indexes[1]; j <= indexes[3]; j++) {
                    i = indexes[0];
                    firstCell = getCell(i, j, sheet, false, true);
                    if (firstCell.rowSpan > 0) {
                        lastCell = getCell(indexes[2], indexes[1], sheet, false, true);
                    }
                    else {
                        lastCell = getCell(indexes[2], indexes[3], sheet, false, true);
                    }
                    if (!(firstCell.rowSpan > 1 && lastCell.rowSpan < 0)) {
                        i = indexes[2];
                    }
                    const mergeArgs = { range: [i, j, i, j] };
                    this.parent.notify(activeCellMergedRange, mergeArgs);
                    i = mergeArgs.range[0];
                    if (!triggerBeforeEvent({ borderBottom: eventArgs.style.borderBottom })) {
                        if (!args.isUndoRedo) {
                            this.checkAdjacentBorder(sheet, 'borderTop', indexes[2] + 1, j);
                            this.checkFullBorder(sheet, 'borderTop', indexes[2] + 1, j);
                        }
                        this.checkFullBorder(sheet, 'borderBottom', indexes[2], j);
                        this.setCellBorder(sheet, props.cell.style, i, j, args.onActionUpdate, j === indexes[3], null, null, args.isUndoRedo);
                        this.setBottomBorderPriority(sheet, indexes[2], j);
                    }
                }
                delete eventArgs.style.borderBottom;
            }
            if (eventArgs.style.borderLeft !== undefined) {
                for (let i = indexes[0]; i <= indexes[2]; i++) {
                    let adjacentJ;
                    if (this.parent.enableRtl) {
                        j = indexes[3];
                        adjacentJ = j + 1;
                    }
                    else {
                        j = indexes[1];
                        adjacentJ = j - 1;
                    }
                    if (!triggerBeforeEvent({ borderLeft: eventArgs.style.borderLeft })) {
                        if (!args.isUndoRedo) {
                            this.checkAdjacentBorder(sheet, 'borderRight', i, adjacentJ);
                            this.checkFullBorder(sheet, 'borderRight', i, adjacentJ);
                        }
                        this.checkFullBorder(sheet, 'borderLeft', i, j);
                        this.setCellBorder(sheet, props.cell.style, i, j, args.onActionUpdate, null, null, null, args.isUndoRedo);
                    }
                }
                delete eventArgs.style.borderLeft;
            }
            if (eventArgs.style.borderRight !== undefined) {
                for (let i = indexes[0]; i <= indexes[2]; i++) {
                    let adjacentJ;
                    if (this.parent.enableRtl) {
                        j = indexes[1];
                        adjacentJ = j - 1;
                    }
                    else {
                        j = indexes[3];
                        adjacentJ = j + 1;
                    }
                    const mergeArgs = { range: [i, j, i, j] };
                    this.parent.notify(activeCellMergedRange, mergeArgs);
                    j = mergeArgs.range[1];
                    if (!triggerBeforeEvent({ borderRight: eventArgs.style.borderRight })) {
                        if (!args.isUndoRedo) {
                            this.checkAdjacentBorder(sheet, 'borderLeft', i, adjacentJ);
                            this.checkFullBorder(sheet, 'borderLeft', i, adjacentJ);
                        }
                        this.checkFullBorder(sheet, 'borderRight', i, j);
                        this.setCellBorder(sheet, props.cell.style, i, j, args.onActionUpdate, null, null, null, args.isUndoRedo);
                    }
                }
                delete eventArgs.style.borderRight;
            }
            if (index === 0) {
                updateStyles = updateStylesFn();
            }
            updateStyles();
            updateMergeBorder(this.parent, mergeBorderRows, [indexes[1], indexes[3]]);
            this.parent.setUsedRange(indexes[2], indexes[3]);
            if (sheet.conditionalFormats && sheet.conditionalFormats.length) {
                this.parent.notify(applyCF, { indexes: indexes });
            }
        });
        if (args.refreshRibbon) {
            this.parent.notify(activeCellChanged, null);
        }
        if (triggerEvt) {
            eventArgs.style = style;
            eventArgs.range = `${sheet.name}!${rng}`;
            this.parent.notify('actionComplete', { eventArgs: eventArgs, action: 'format' });
        }
    }
    setBottomBorderPriority(sheet, rowIdx, colIdx) {
        if (isHiddenRow(sheet, rowIdx + 1)) {
            const pIdx = this.skipHiddenRows(sheet, rowIdx + 1);
            const pCellStyle = this.parent.getCellStyleValue(['borderTop'], [pIdx, colIdx]).borderTop;
            if (pCellStyle !== '') {
                sheet.rows[rowIdx].cells[colIdx].style.bottomPriority = true;
            }
        }
    }
    setFullBorder(sheet, border, indexes, i, j, actionUpdate, modelUpdate, mergeBorderRows) {
        const style = {};
        if (i === indexes[0]) {
            this.checkAdjacentBorder(sheet, 'borderBottom', i - 1, j);
            this.checkFullBorder(sheet, 'borderBottom', i - 1, j);
        }
        if (j === indexes[1]) {
            this.checkAdjacentBorder(sheet, 'borderRight', i, j - 1);
            this.checkFullBorder(sheet, 'borderRight', i, j - 1);
        }
        if (j === indexes[3]) {
            this.checkAdjacentBorder(sheet, 'borderLeft', i, j + 1);
            this.checkFullBorder(sheet, 'borderLeft', i, j + 1);
        }
        else {
            this.checkAdjacentBorder(sheet, 'border', i, j + 1);
        }
        style.borderRight = border;
        style.borderTop = border;
        style.borderLeft = border;
        style.borderBottom = border;
        this.setCellBorder(sheet, style, i, j, actionUpdate, j === indexes[3], null, modelUpdate, undefined, mergeBorderRows);
        if (i === indexes[2]) {
            this.checkAdjacentBorder(sheet, 'borderTop', i + 1, j);
            this.checkFullBorder(sheet, 'borderTop', i + 1, j);
            this.setBottomBorderPriority(sheet, i, j);
        }
        else {
            this.checkAdjacentBorder(sheet, 'border', i + 1, j);
        }
    }
    checkAdjacentBorder(sheet, prop, rowIdx, colIdx) {
        const style = {};
        if (this.parent.getCellStyleValue([prop], [rowIdx, colIdx])[`${prop}`] !== '') {
            style[`${prop}`] = undefined;
            this.setCellStyle(sheet, rowIdx, colIdx, style);
        }
    }
    checkFullBorder(sheet, prop, rowIdx, colIdx) {
        const border = this.parent.getCellStyleValue(['border'], [rowIdx, colIdx]).border;
        if (border !== '') {
            const style = { border: undefined };
            ['borderBottom', 'borderTop', 'borderLeft', 'borderRight'].forEach((value) => {
                if (value !== prop) {
                    style[`${value}`] = border;
                }
            });
            this.setCellStyle(sheet, rowIdx, colIdx, style);
        }
    }
    textDecorationActionUpdate(args) {
        const sheet = this.parent.getActiveSheet();
        const rng = sheet.selectedRange;
        let ranges = rng.split(' ');
        if (ranges.some((rng) => isReadOnlyCells(this.parent, getSwapRange(getRangeIndexes(rng)), true))) {
            return;
        }
        const eventArgs = { range: rng, style: args.style, requestType: 'CellFormat' };
        this.parent.trigger('beforeCellFormat', eventArgs);
        this.parent.notify('actionBegin', { eventArgs: eventArgs, action: 'format' });
        if (eventArgs.cancel) {
            args.cancel = true;
            return;
        }
        if (eventArgs.range !== rng) {
            ranges = eventArgs.range.split(' ');
        }
        const value = eventArgs.style.textDecoration.toLowerCase();
        let changedValue = value;
        const activeCellIndexes = getRangeIndexes(sheet.activeCell);
        let cellValue = this.parent.getCellStyleValue(['textDecoration'], activeCellIndexes).textDecoration.toLowerCase();
        let removeProp = false;
        if (cellValue === 'underline') {
            changedValue = value === 'underline' ? 'none' : 'underline line-through';
        }
        else if (cellValue === 'line-through') {
            changedValue = value === 'line-through' ? 'none' : 'underline line-through';
        }
        else if (cellValue === 'underline line-through') {
            changedValue = value === 'underline' ? 'line-through' : 'underline';
            removeProp = true;
        }
        if (changedValue === 'none') {
            removeProp = true;
        }
        let changedStyle = { textDecoration: changedValue };
        let indexes;
        this.format({ style: changedStyle, range: activeCellIndexes, refreshRibbon: args.refreshRibbon, onActionUpdate: true });
        ranges.forEach((currentRange) => {
            indexes = getSwapRange(getRangeIndexes(currentRange));
            for (let i = indexes[0]; i <= indexes[2]; i++) {
                for (let j = indexes[1]; j <= indexes[3]; j++) {
                    if (i === activeCellIndexes[0] && j === activeCellIndexes[1]) {
                        continue;
                    }
                    changedStyle = {};
                    cellValue = this.parent.getCellStyleValue(['textDecoration'], [i, j]).textDecoration.toLowerCase();
                    if (cellValue === 'none') {
                        if (removeProp) {
                            continue;
                        }
                        changedStyle.textDecoration = value;
                    }
                    else if (cellValue === 'underline' || cellValue === 'line-through') {
                        if (removeProp) {
                            if (value === cellValue) {
                                changedStyle.textDecoration = 'none';
                            }
                            else {
                                continue;
                            }
                        }
                        else {
                            changedStyle.textDecoration = value !== cellValue ? 'underline line-through' : value;
                        }
                    }
                    else if (cellValue === 'underline line-through') {
                        if (removeProp) {
                            changedStyle.textDecoration = value === 'underline' ? 'line-through' : 'underline';
                        }
                        else {
                            continue;
                        }
                    }
                    this.format({ style: changedStyle, range: [i, j, i, j], refreshRibbon: args.refreshRibbon, onActionUpdate: true });
                }
            }
        });
        eventArgs.range = sheet.name + '!' + eventArgs.range;
        eventArgs.style.textDecoration = changedValue;
        this.parent.notify('actionComplete', { eventArgs: eventArgs, action: 'format' });
    }
    setTypedBorder(sheet, border, range, type, actionUpdate, mergeBorderRows) {
        let prevBorder;
        if (type === 'Outer') {
            for (let colIdx = range[1]; colIdx <= range[3]; colIdx++) {
                this.checkAdjacentBorder(sheet, 'borderBottom', range[0] - 1, colIdx);
                this.checkFullBorder(sheet, 'borderBottom', range[0] - 1, colIdx);
                this.setCellBorder(sheet, { borderTop: border }, range[0], colIdx, actionUpdate, colIdx === range[3], undefined, undefined, undefined, mergeBorderRows);
                this.checkAdjacentBorder(sheet, 'borderTop', range[2] + 1, colIdx);
                this.checkFullBorder(sheet, 'borderTop', range[2] + 1, colIdx);
                this.setCellBorder(sheet, { borderBottom: border }, range[2], colIdx, actionUpdate, colIdx === range[3], type);
                this.setBottomBorderPriority(sheet, range[2], colIdx);
            }
            for (let rowIdx = range[0]; rowIdx <= range[2]; rowIdx++) {
                if (this.parent.enableRtl) {
                    this.checkAdjacentBorder(sheet, 'borderLeft', rowIdx, range[1] + 1);
                    this.checkFullBorder(sheet, 'borderLeft', rowIdx, range[1] + 1);
                    this.setCellBorder(sheet, { borderRight: border }, rowIdx, range[1], actionUpdate);
                    this.checkAdjacentBorder(sheet, 'borderRight', rowIdx, range[3] - 1);
                    this.checkFullBorder(sheet, 'borderRight', rowIdx, range[3] - 1);
                    this.setCellBorder(sheet, { borderLeft: border }, rowIdx, range[3], actionUpdate, null, type);
                }
                else {
                    this.checkAdjacentBorder(sheet, 'borderRight', rowIdx, range[1] - 1);
                    this.checkFullBorder(sheet, 'borderRight', rowIdx, range[1] - 1);
                    this.setCellBorder(sheet, { borderLeft: border }, rowIdx, range[1], actionUpdate);
                    this.checkAdjacentBorder(sheet, 'borderLeft', rowIdx, range[3] + 1);
                    this.checkFullBorder(sheet, 'borderLeft', rowIdx, range[3] + 1);
                    this.setCellBorder(sheet, { borderRight: border }, rowIdx, range[3], actionUpdate, null, type);
                }
            }
        }
        else if (type === 'Inner') {
            const mergeArgs = { range: [range[0], range[1], range[0], range[1]] };
            this.parent.notify(mergedRange, mergeArgs);
            if (mergeArgs.range[0] === range[0] && mergeArgs.range[1] === range[1] &&
                mergeArgs.range[2] === range[2] && mergeArgs.range[3] === range[3]) {
                return;
            }
            for (let i = range[0]; i <= range[2]; i++) {
                for (let j = range[1]; j <= range[3]; j++) {
                    const style = {};
                    prevBorder = this.parent.getCellStyleValue(['border'], [i, j]).border;
                    if (prevBorder !== '') {
                        style.border = undefined;
                        if (j === range[3] || j === range[1] || i === range[0] || i === range[2]) {
                            if (i === range[0]) {
                                style.borderTop = prevBorder;
                            }
                            if (i === range[2]) {
                                style.borderBottom = prevBorder;
                            }
                            if (j === range[3]) {
                                style.borderRight = prevBorder;
                            }
                            if (j === range[1]) {
                                style.borderLeft = prevBorder;
                            }
                        }
                    }
                    if (j !== range[3]) {
                        style.borderRight = border;
                    }
                    if (i !== range[0]) {
                        style.borderTop = border;
                    }
                    if (i !== range[2]) {
                        style.borderBottom = border;
                    }
                    if (j !== range[1]) {
                        style.borderLeft = border;
                    }
                    this.setCellBorder(sheet, style, i, j, actionUpdate, j === range[3], undefined, undefined, undefined, mergeBorderRows);
                }
            }
        }
        else if (type === 'Vertical') {
            for (let i = range[0]; i <= range[2]; i++) {
                for (let j = range[1]; j <= range[3]; j++) {
                    const style = { borderRight: border, borderLeft: border };
                    if (j === range[1]) {
                        this.checkAdjacentBorder(sheet, 'borderRight', i, j - 1);
                        this.checkFullBorder(sheet, 'borderRight', i, j - 1);
                    }
                    if (j === range[3]) {
                        this.checkAdjacentBorder(sheet, 'borderLeft', i, j + 1);
                        this.checkFullBorder(sheet, 'borderLeft', i, j + 1);
                    }
                    this.setCellBorder(sheet, style, i, j, actionUpdate);
                }
            }
        }
        else {
            for (let i = range[0]; i <= range[2]; i++) {
                for (let j = range[1]; j <= range[3]; j++) {
                    const style = { borderTop: border, borderBottom: border };
                    if (i === range[0]) {
                        this.checkAdjacentBorder(sheet, 'borderBottom', i - 1, j);
                        this.checkFullBorder(sheet, 'borderBottom', i - 1, j);
                    }
                    this.setCellBorder(sheet, style, i, j, actionUpdate, j === range[3]);
                    if (i === range[2]) {
                        this.checkAdjacentBorder(sheet, 'borderTop', i + 1, j);
                        this.checkFullBorder(sheet, 'borderTop', i + 1, j);
                        this.setBottomBorderPriority(sheet, i, j);
                    }
                }
            }
        }
    }
    setCellBorder(sheet, style, rowIdx, colIdx, actionUpdate, lastCell, type, modelUpdate, isUndoRedo, mergeBorderRows) {
        const cell = getCell(rowIdx, colIdx, sheet);
        const column = getColumn(sheet, colIdx);
        const row = getRow(sheet, rowIdx);
        if ((cell && cell.isReadOnly) || (column && column.isReadOnly) || (row && row.isReadOnly)) {
            return;
        }
        this.setCellStyle(sheet, rowIdx, colIdx, style);
        if (!modelUpdate && this.parent.getActiveSheet().id === sheet.id) {
            if (type === 'Outer' && (style.borderBottom || style.borderRight)) {
                const mergeArgs = { range: [rowIdx, colIdx, rowIdx, colIdx] };
                this.parent.notify(activeCellMergedRange, mergeArgs);
                rowIdx = mergeArgs.range[0];
                colIdx = mergeArgs.range[1];
            }
            if (isUndoRedo) {
                if (style.borderTop === '' && this.parent.getCellStyleValue(['borderBottom'], [rowIdx - 1, colIdx]).borderBottom !== '') {
                    style.borderTop = this.parent.getCellStyleValue(['borderBottom'], [rowIdx - 1, colIdx]).borderBottom;
                }
                if (style.borderLeft === '' && this.parent.getCellStyleValue(['borderRight'], [rowIdx, colIdx - 1]).borderRight !== '') {
                    style.borderLeft = this.parent.getCellStyleValue(['borderRight'], [rowIdx, colIdx - 1]).borderRight;
                }
                if (style.borderRight === '' && this.parent.getCellStyleValue(['borderLeft'], [rowIdx, colIdx + 1]).borderLeft !== '') {
                    style.borderRight = this.parent.getCellStyleValue(['borderLeft'], [rowIdx, colIdx + 1]).borderLeft;
                }
            }
            this.parent.notify(applyCellFormat, {
                style: style, rowIdx: rowIdx, colIdx: colIdx, onActionUpdate: actionUpdate, first: '', lastCell: lastCell,
                isHeightCheckNeeded: true, manualUpdate: true, mergeBorderRows: mergeBorderRows
            });
        }
    }
    setCellStyle(sheet, rowIdx, colIdx, style) {
        if (!sheet.rows[rowIdx]) {
            sheet.rows[rowIdx] = { cells: [] };
        }
        else if (!sheet.rows[rowIdx].cells) {
            sheet.rows[rowIdx].cells = [];
        }
        if (!sheet.rows[rowIdx].cells[colIdx]) {
            sheet.rows[rowIdx].cells[colIdx] = {};
        }
        if (!sheet.rows[rowIdx].cells[colIdx].style) {
            sheet.rows[rowIdx].cells[colIdx].style = {};
        }
        Object.assign(sheet.rows[rowIdx].cells[colIdx].style, style, null, true);
    }
    skipHiddenRows(sheet, startIdx) {
        startIdx++;
        if (isHiddenRow(sheet, startIdx)) {
            startIdx = this.skipHiddenRows(sheet, startIdx);
        }
        return startIdx;
    }
    addEventListener() {
        this.parent.on(setCellFormat, this.format, this);
        this.parent.on(textDecorationUpdate, this.textDecorationActionUpdate, this);
        this.parent.on(clear, this.clearCellObj, this);
    }
    removeEventListener() {
        if (!this.parent.isDestroyed) {
            this.parent.off(setCellFormat, this.format);
            this.parent.off(textDecorationUpdate, this.textDecorationActionUpdate);
            this.parent.off(clear, this.clearCellObj);
        }
    }
    clearCellObj(options) {
        const lastIndex = options.range ? options.range.lastIndexOf('!') : 0;
        const clrRange = options.range ? (lastIndex > 0) ? options.range.substring(lastIndex + 1) : options.range
            : this.parent.getActiveSheet().selectedRange;
        const sheetIdx = (options.range && lastIndex > 0) ?
            getSheetIndex(this.parent, options.range.substring(0, lastIndex)) : this.parent.activeSheetIndex;
        const sheet = getSheet(this.parent, sheetIdx);
        const range = getSwapRange(getIndexesFromAddress(clrRange));
        let sRowIdx = range[0];
        const eRowIdx = range[2];
        const cf = sheet.conditionalFormats && sheet.conditionalFormats.length &&
            [].slice.call(sheet.conditionalFormats);
        const cfRule = [];
        let cfRefreshAll;
        let evtArgs;
        let sColIdx;
        let eColIdx;
        let isValExist;
        for (sRowIdx; sRowIdx <= eRowIdx; sRowIdx++) {
            sColIdx = range[1];
            eColIdx = range[3];
            for (sColIdx; sColIdx <= eColIdx; sColIdx++) {
                const cell = getCell(sRowIdx, sColIdx, sheet);
                const isReadonlyCell = isReadOnly(cell, getColumn(sheet, sColIdx), getRow(sheet, sRowIdx));
                if (cell && (options.type === 'Clear All' || options.type === 'Clear Formats')) {
                    if (cell.rowSpan > 1 || cell.colSpan > 1) {
                        const mergeArgs = { range: [sRowIdx, sColIdx, sRowIdx, sColIdx] };
                        this.parent.notify(mergedRange, mergeArgs);
                        const mergedRanges = mergeArgs.range;
                        if (range[0] <= mergedRanges[0] && range[1] <= mergedRanges[1] && range[2] >= mergedRanges[2] &&
                            range[3] >= mergedRanges[3]) {
                            this.parent.notify(setMerge, { merge: false, range: mergedRanges, type: 'All', sheetIndex: sheetIdx,
                                preventRefresh: sheetIdx !== this.parent.activeSheetIndex });
                        }
                    }
                    if (!!cell.rowSpan && cell.rowSpan !== 1 || !!cell.colSpan && cell.colSpan !== 1) {
                        continue;
                    }
                }
                if (cell && !isReadonlyCell) {
                    switch (options.type) {
                        case 'Clear Formats':
                            delete cell.format;
                            delete cell.rowSpan;
                            delete cell.style;
                            delete cell.wrap;
                            delete cell.colSpan;
                            delete cell.formattedText;
                            if (cell.hyperlink) {
                                cell.style = { textDecoration: 'none', color: 'inherit' };
                            }
                            break;
                        case 'Clear Contents':
                            if (cell.hyperlink) {
                                this.parent.notify(deleteHyperlink, { sheet: sheet, rowIdx: sRowIdx, colIdx: sColIdx, preventRefresh: true });
                                cell.style = { textDecoration: 'underline', color: '#00e' };
                            }
                            isValExist = !!(cell.value || cell.formula);
                            delete cell.value;
                            delete cell.formula;
                            delete cell.formattedText;
                            if (isValExist) {
                                evtArgs = { action: 'refreshCalculate', rowIndex: sRowIdx, colIndex: sColIdx, sheetIndex: sheetIdx };
                                this.parent.notify(workbookFormulaOperation, evtArgs);
                                if (cf && !cfRefreshAll) {
                                    cfRefreshAll = evtArgs.isFormulaDependent;
                                    if (!cfRefreshAll) {
                                        updateCFModel(cf, cfRule, sRowIdx, sColIdx);
                                    }
                                }
                            }
                            break;
                        case 'Clear Hyperlinks':
                            delete cell.hyperlink;
                            break;
                        case 'Clear All':
                            isValExist = !!(cell.value || cell.formula);
                            if (cell.comment) {
                                this.parent.notify(processSheetComments, {
                                    sheet: sheet, id: cell.comment.id,
                                    isDelete: true, isRefresh: true, sheetIdx: sheetIdx
                                });
                            }
                            if (cell.notes) {
                                this.parent.notify(processSheetNotes, { sheet: sheet, id: cell.notes.id, isDelete: true });
                            }
                            setCell(sRowIdx, sColIdx, sheet, {}, false);
                            if (isValExist) {
                                evtArgs = { action: 'refreshCalculate', rowIndex: sRowIdx, colIndex: sColIdx, sheetIndex: sheetIdx };
                                this.parent.notify(workbookFormulaOperation, evtArgs);
                                if (cf && !cfRefreshAll) {
                                    cfRefreshAll = evtArgs.isFormulaDependent;
                                }
                            }
                            break;
                    }
                }
            }
        }
        if ((cfRule.length || cfRefreshAll) && sheetIdx === this.parent.activeSheetIndex) {
            this.parent.notify(applyCF, { cfModel: !cfRefreshAll && cfRule, refreshAll: cfRefreshAll, isAction: true });
        }
    }
    /**
     * To destroy workbook cell format.
     *
     * @returns {void} - To destroy workbook cell format.
     */
    destroy() {
        this.removeEventListener();
        this.parent = null;
    }
    /**
     * Get the workbook cell format module name.
     *
     *  @returns {void}
     */
    getModuleName() {
        return 'workbookcellformat';
    }
}
